document.addEventListener( 'DOMContentLoaded', function () {
	const MOBILE_BREAKPOINT = 768;
	const CARDS_PER_PAGE = 3;
	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
	const sections = document.querySelectorAll( '.awards-section' );

	/* ── Shared mouse-drag state (at most one dragging section at a time) ── */
	let activeDrag = null;

	window.addEventListener( 'mousemove', function ( e ) {
		if ( ! activeDrag ) return;
		activeDrag.onMove( e );
	} );

	window.addEventListener( 'mouseup', function () {
		if ( ! activeDrag ) return;
		activeDrag.onEnd();
	} );

	window.addEventListener( 'dragend', function () {
		if ( ! activeDrag ) return;
		activeDrag.onEnd();
	} );

	sections.forEach( function ( section ) {
		const slider = section.querySelector( '.awards-section__slider' );
		const grid = section.querySelector( '.awards-section__grid' );
		const cards = section.querySelectorAll( '.awards-section__card' );
		const dots = section.querySelectorAll( '.awards-section__pagination-dot' );

		if ( ! grid || cards.length === 0 ) {
			return;
		}

		let currentIndex = 0;
		let mobilePages = [];
		let isMobileMode = false;
		let overflowAnchorTimer = null;

		/* ── Mobile page grouping ─────────────────────────────────────────── */

		function buildMobilePages() {
			if ( isMobileMode ) return;
			isMobileMode = true;
			mobilePages = [];

			const cardArray = Array.from( cards );
			cardArray.forEach( function ( c ) { c.remove(); } );

			const pageWidth = slider ? slider.offsetWidth : grid.offsetWidth;

			for ( let i = 0; i < cardArray.length; i += CARDS_PER_PAGE ) {
				const pageEl = document.createElement( 'div' );
				pageEl.className = 'awards-section__mobile-page';
				pageEl.style.width = pageWidth + 'px';
				cardArray.slice( i, i + CARDS_PER_PAGE ).forEach( function ( c ) {
					pageEl.appendChild( c );
				} );
				grid.appendChild( pageEl );
				mobilePages.push( pageEl );
			}

			/* Show only as many dots as there are pages */
			dots.forEach( function ( dot, i ) {
				dot.style.display = i < mobilePages.length ? '' : 'none';
			} );
		}

		function teardownMobilePages() {
			if ( ! isMobileMode ) return;
			isMobileMode = false;

			/* Restore cards in original order using the captured NodeList */
			Array.from( cards ).forEach( function ( c ) { grid.appendChild( c ); } );
			grid.querySelectorAll( '.awards-section__mobile-page' ).forEach( function ( p ) {
				p.remove();
			} );
			mobilePages = [];

			dots.forEach( function ( dot ) { dot.style.display = ''; } );
		}

		/* ── Index helpers ────────────────────────────────────────────────── */

		function getMaxIndex() {
			if ( window.innerWidth < MOBILE_BREAKPOINT ) {
				return Math.max( 0, mobilePages.length - 1 );
			}
			if ( ! slider ) {
				return cards.length - 1;
			}
			const sliderWidth = slider.offsetWidth;
			let maxIdx = 0;
			for ( let i = cards.length - 1; i >= 0; i-- ) {
				const cardLeft = cards[ i ].offsetLeft - grid.offsetLeft;
				const gridWidth = grid.scrollWidth;
				if ( gridWidth - cardLeft > sliderWidth ) {
					maxIdx = Math.min( i + 1, cards.length - 1 );
					break;
				}
			}
			return maxIdx;
		}

		function getTranslateX( index ) {
			if ( window.innerWidth < MOBILE_BREAKPOINT ) {
				return index * ( slider ? slider.offsetWidth : grid.offsetWidth );
			}
			if ( index === 0 ) return 0;
			return cards[ index ].offsetLeft - cards[ 0 ].offsetLeft;
		}

		/* ── Core navigation ──────────────────────────────────────────────── */

		function goTo( index, { skipScroll = false } = {} ) {
			const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

			if ( isMobile ) {
				buildMobilePages();
			} else {
				teardownMobilePages();
			}

			const maxIdx = getMaxIndex();
			currentIndex = Math.max( 0, Math.min( index, maxIdx ) );

			const tx = getTranslateX( currentIndex );
			if ( prefersReducedMotion.matches ) {
				grid.style.transition = 'none';
			}
			grid.style.transform = 'translate3d(-' + tx + 'px, 0, 0)';
			if ( prefersReducedMotion.matches ) {
				void grid.offsetHeight;
				grid.style.transition = '';
			}

			// On mobile, shrink/grow the slider to the active page's natural height
			// so pages with fewer cards don't leave a blank gap.
			// Scroll the section's top edge to the viewport top before the height
			// transition fires so the section stays fully in view — skipped when
			// the call isn't user-initiated, otherwise the page jumps to this
			// section on initial load.
			// Note: overflow-anchor is unsupported in Safari — the block below
			// no-ops there and Safari users may see a small scroll shift.
			if ( isMobile && section && slider && mobilePages[ currentIndex ] ) {
				if ( ! skipScroll ) {
					document.documentElement.style.overflowAnchor = 'none';
					const sectionTop = section.getBoundingClientRect().top + window.scrollY;
					window.scrollTo( { top: sectionTop, behavior: 'instant' } );
					clearTimeout( overflowAnchorTimer );
					overflowAnchorTimer = setTimeout( function () {
						document.documentElement.style.overflowAnchor = '';
					}, 550 );
				}
				slider.style.height = mobilePages[ currentIndex ].scrollHeight + 'px';
			} else if ( ! isMobile && slider ) {
				clearTimeout( overflowAnchorTimer );
				document.documentElement.style.overflowAnchor = '';
				slider.style.height = '';
			}

			const numActive = isMobile ? mobilePages.length : dots.length;
			dots.forEach( function ( dot, i ) {
				if ( i >= numActive ) return;
				dot.classList.toggle( 'is-active', i === currentIndex );
			} );
		}

		/* ── Dot clicks + keyboard ────────────────────────────────────────── */

		dots.forEach( function ( dot, i ) {
			dot.style.cursor = 'pointer';
			dot.addEventListener( 'click', function () {
				goTo( i );
			} );
			dot.addEventListener( 'keydown', function ( e ) {
				if ( e.key === 'Enter' || e.key === ' ' ) {
					e.preventDefault();
					goTo( i );
				}
			} );
		} );

		/* ── Mouse drag support ───────────────────────────────────────────── */

		let mouseStartX = 0;
		let mouseDelta = 0;

		grid.addEventListener( 'mousedown', function ( e ) {
			mouseStartX = e.clientX;
			mouseDelta = 0;
			grid.style.transition = 'none';
			grid.classList.add( 'is-dragging' );
			activeDrag = {
				onMove: function ( moveEvt ) {
					const delta = moveEvt.clientX - mouseStartX;
					if ( Math.abs( delta ) > 5 ) {
						moveEvt.preventDefault(); // suppress default only when actually dragging
					}
					mouseDelta = delta;
					const currentTx = getTranslateX( currentIndex );
					grid.style.transform = 'translate3d(' + ( -currentTx + mouseDelta ) + 'px, 0, 0)';
				},
				onEnd: function () {
					activeDrag = null;
					grid.classList.remove( 'is-dragging' );
					grid.style.transition = '';
					if ( mouseDelta < -50 ) {
						goTo( currentIndex + 1 );
					} else if ( mouseDelta > 50 ) {
						goTo( currentIndex - 1 );
					} else {
						goTo( currentIndex );
					}
				},
			};
		} );

		grid.addEventListener( 'dragstart', function ( e ) {
			e.preventDefault();
		} );

		grid.addEventListener( 'click', function ( e ) {
			if ( Math.abs( mouseDelta ) > 5 ) {
				e.stopPropagation();
				e.preventDefault();
			}
		}, true );

		/* ── Touch/swipe support ──────────────────────────────────────────── */

		let touchStartX = 0;
		let touchStartY = 0;
		let touchDelta = 0;

		grid.addEventListener( 'touchstart', function ( e ) {
			touchStartX = e.touches[ 0 ].clientX;
			touchStartY = e.touches[ 0 ].clientY;
			touchDelta = 0;
			grid.style.transition = 'none';
		}, { passive: true } );

		grid.addEventListener( 'touchmove', function ( e ) {
			touchDelta = e.touches[ 0 ].clientX - touchStartX;
			const vertDelta = e.touches[ 0 ].clientY - touchStartY;
			// Only intercept when movement is primarily horizontal
			if ( Math.abs( touchDelta ) > Math.abs( vertDelta ) ) {
				e.preventDefault();
			}
			const currentTx = getTranslateX( currentIndex );
			grid.style.transform = 'translate3d(' + ( -currentTx + touchDelta ) + 'px, 0, 0)';
		}, { passive: false } );

		grid.addEventListener( 'touchend', function () {
			grid.style.transition = '';
			if ( touchDelta < -50 ) {
				goTo( currentIndex + 1 );
			} else if ( touchDelta > 50 ) {
				goTo( currentIndex - 1 );
			} else {
				goTo( currentIndex );
			}
		} );

		/* ── Resize handler ───────────────────────────────────────────────── */

		let resizeTimeout;
		window.addEventListener( 'resize', function () {
			clearTimeout( resizeTimeout );
			resizeTimeout = setTimeout( function () {
				/* Tear down so pages are rebuilt at the new width */
				teardownMobilePages();
				currentIndex = 0;
				goTo( 0, { skipScroll: true } );
			}, 150 );
		} );

		/* ── Initial state ────────────────────────────────────────────────── */

		goTo( 0, { skipScroll: true } );
	} );
} );
